/* eslint-disable */
import { Receipt_DonationUnit } from "../../../../api/orders/resources";
import { FieldMask } from "../../../../google/protobuf/field_mask";
import { Announcement } from "../../common/common";
import { PushSettings, VerifyCodeCredential } from "../resources";

export const protobufPackage = "store.api.auth.v1";

export interface GetProfileStatesResponse {
  /** 歡迎詞 */
  welcomeMessage: string;
  /** 待出貨筆數 */
  waitSellerSend: number;
  /** 待收貨筆數 */
  waitBuyerConfirm: number;
  /** 待評價筆數 */
  waitRating: number;
  /** 退貨進度筆數 */
  hasReturn: number;
  /** 退款帳戶金額 */
  returnBalance: string;
  /** 收藏商品數 */
  favorites: number;
  /** 到貨提醒商品數 */
  stockReminders: number;
  /** 公告 */
  announcement: Announcement | undefined;
}

export interface LinkWithVerifyCodeRequest {
  /** Verify account */
  verify:
    | VerifyCodeCredential
    | undefined;
  /** 6-digit code string */
  code: string;
}

export interface DeleteAccountRequest {
  /** Require. Used for knowing the deletion will be successful or not. */
  dryRun: boolean;
}

export interface UpdateProfileRequest {
  /**
   * User display name. Optional.
   * Update only applied if this field is provided.
   */
  displayName:
    | string
    | undefined;
  /**
   * User photo url. Optional.
   * Update only applied if this field is provided.
   */
  photoUrl: string | undefined;
}

export interface GetProfileRequest {
  /** A mask to filter profile result. */
  mask: string[] | undefined;
}

export interface RegisterPushTokenRequest {
  /** Required. Push token. */
  token: string;
}

export interface UnregisterPushTokenRequest {
  /** Required. Push token. */
  token: string;
}

export interface ReceiptSettings {
  /** Required. 手機條碼 */
  mobileBarcode: string;
  /** Required. 統一編號 */
  taxId: string;
  /** Required. 捐贈碼 */
  donateUnitId: string;
}

export interface GetReceiptSettingsRequest {
  /** Optional. */
  mask: string[] | undefined;
}

export interface GetReceiptSettingsResponse {
  /** 發票設定 */
  receiptSettings:
    | ReceiptSettings
    | undefined;
  /** 捐贈單位清單 */
  donations: Receipt_DonationUnit[];
  /** 歸戶設定 */
  registrationSettings: GetReceiptSettingsResponse_RegistrationSettings | undefined;
}

export interface GetReceiptSettingsResponse_RegistrationSettings {
  /** 公司統一編號 */
  companyId: string;
  /** 載具類別 */
  cardType: string;
  /** 載具條碼 */
  cardNo: string;
  token: string;
  /** 歸戶網址 */
  url: string;
}

export interface UpdateReceiptSettingsRequest {
  /** 發票設定 */
  receiptSettings: ReceiptSettings | undefined;
}

export interface UpdateReceiptSettingsResponse {
  /** 發票設定 */
  receiptSettings: ReceiptSettings | undefined;
}

export interface GetPushSettingsRequest {
  /** Optional. A mask to filter settings result. */
  mask: string[] | undefined;
}

export interface UpdatePushSettingsRequest {
  /** Required. Push settings. */
  settings:
    | PushSettings
    | undefined;
  /** Optional. A mask to determine which settings to update. */
  updateMask: string[] | undefined;
}

function createBaseGetProfileStatesResponse(): GetProfileStatesResponse {
  return {
    welcomeMessage: "",
    waitSellerSend: 0,
    waitBuyerConfirm: 0,
    waitRating: 0,
    hasReturn: 0,
    returnBalance: "",
    favorites: 0,
    stockReminders: 0,
    announcement: undefined,
  };
}

export const GetProfileStatesResponse = {
  fromJSON(object: any): GetProfileStatesResponse {
    return {
      welcomeMessage: isSet(object.welcomeMessage) ? String(object.welcomeMessage) : "",
      waitSellerSend: isSet(object.waitSellerSend) ? Number(object.waitSellerSend) : 0,
      waitBuyerConfirm: isSet(object.waitBuyerConfirm) ? Number(object.waitBuyerConfirm) : 0,
      waitRating: isSet(object.waitRating) ? Number(object.waitRating) : 0,
      hasReturn: isSet(object.hasReturn) ? Number(object.hasReturn) : 0,
      returnBalance: isSet(object.returnBalance) ? String(object.returnBalance) : "",
      favorites: isSet(object.favorites) ? Number(object.favorites) : 0,
      stockReminders: isSet(object.stockReminders) ? Number(object.stockReminders) : 0,
      announcement: isSet(object.announcement) ? Announcement.fromJSON(object.announcement) : undefined,
    };
  },

  toJSON(message: GetProfileStatesResponse): unknown {
    const obj: any = {};
    message.welcomeMessage !== undefined && (obj.welcomeMessage = message.welcomeMessage);
    message.waitSellerSend !== undefined && (obj.waitSellerSend = Math.round(message.waitSellerSend));
    message.waitBuyerConfirm !== undefined && (obj.waitBuyerConfirm = Math.round(message.waitBuyerConfirm));
    message.waitRating !== undefined && (obj.waitRating = Math.round(message.waitRating));
    message.hasReturn !== undefined && (obj.hasReturn = Math.round(message.hasReturn));
    message.returnBalance !== undefined && (obj.returnBalance = message.returnBalance);
    message.favorites !== undefined && (obj.favorites = Math.round(message.favorites));
    message.stockReminders !== undefined && (obj.stockReminders = Math.round(message.stockReminders));
    message.announcement !== undefined &&
      (obj.announcement = message.announcement ? Announcement.toJSON(message.announcement) : undefined);
    return obj;
  },

  create<I extends Exact<DeepPartial<GetProfileStatesResponse>, I>>(base?: I): GetProfileStatesResponse {
    return GetProfileStatesResponse.fromPartial(base ?? {});
  },

  fromPartial<I extends Exact<DeepPartial<GetProfileStatesResponse>, I>>(object: I): GetProfileStatesResponse {
    const message = createBaseGetProfileStatesResponse();
    message.welcomeMessage = object.welcomeMessage ?? "";
    message.waitSellerSend = object.waitSellerSend ?? 0;
    message.waitBuyerConfirm = object.waitBuyerConfirm ?? 0;
    message.waitRating = object.waitRating ?? 0;
    message.hasReturn = object.hasReturn ?? 0;
    message.returnBalance = object.returnBalance ?? "";
    message.favorites = object.favorites ?? 0;
    message.stockReminders = object.stockReminders ?? 0;
    message.announcement = (object.announcement !== undefined && object.announcement !== null)
      ? Announcement.fromPartial(object.announcement)
      : undefined;
    return message;
  },
};

function createBaseLinkWithVerifyCodeRequest(): LinkWithVerifyCodeRequest {
  return { verify: undefined, code: "" };
}

export const LinkWithVerifyCodeRequest = {
  fromJSON(object: any): LinkWithVerifyCodeRequest {
    return {
      verify: isSet(object.verify) ? VerifyCodeCredential.fromJSON(object.verify) : undefined,
      code: isSet(object.code) ? String(object.code) : "",
    };
  },

  toJSON(message: LinkWithVerifyCodeRequest): unknown {
    const obj: any = {};
    message.verify !== undefined &&
      (obj.verify = message.verify ? VerifyCodeCredential.toJSON(message.verify) : undefined);
    message.code !== undefined && (obj.code = message.code);
    return obj;
  },

  create<I extends Exact<DeepPartial<LinkWithVerifyCodeRequest>, I>>(base?: I): LinkWithVerifyCodeRequest {
    return LinkWithVerifyCodeRequest.fromPartial(base ?? {});
  },

  fromPartial<I extends Exact<DeepPartial<LinkWithVerifyCodeRequest>, I>>(object: I): LinkWithVerifyCodeRequest {
    const message = createBaseLinkWithVerifyCodeRequest();
    message.verify = (object.verify !== undefined && object.verify !== null)
      ? VerifyCodeCredential.fromPartial(object.verify)
      : undefined;
    message.code = object.code ?? "";
    return message;
  },
};

function createBaseDeleteAccountRequest(): DeleteAccountRequest {
  return { dryRun: false };
}

export const DeleteAccountRequest = {
  fromJSON(object: any): DeleteAccountRequest {
    return { dryRun: isSet(object.dryRun) ? Boolean(object.dryRun) : false };
  },

  toJSON(message: DeleteAccountRequest): unknown {
    const obj: any = {};
    message.dryRun !== undefined && (obj.dryRun = message.dryRun);
    return obj;
  },

  create<I extends Exact<DeepPartial<DeleteAccountRequest>, I>>(base?: I): DeleteAccountRequest {
    return DeleteAccountRequest.fromPartial(base ?? {});
  },

  fromPartial<I extends Exact<DeepPartial<DeleteAccountRequest>, I>>(object: I): DeleteAccountRequest {
    const message = createBaseDeleteAccountRequest();
    message.dryRun = object.dryRun ?? false;
    return message;
  },
};

function createBaseUpdateProfileRequest(): UpdateProfileRequest {
  return { displayName: undefined, photoUrl: undefined };
}

export const UpdateProfileRequest = {
  fromJSON(object: any): UpdateProfileRequest {
    return {
      displayName: isSet(object.displayName) ? String(object.displayName) : undefined,
      photoUrl: isSet(object.photoUrl) ? String(object.photoUrl) : undefined,
    };
  },

  toJSON(message: UpdateProfileRequest): unknown {
    const obj: any = {};
    message.displayName !== undefined && (obj.displayName = message.displayName);
    message.photoUrl !== undefined && (obj.photoUrl = message.photoUrl);
    return obj;
  },

  create<I extends Exact<DeepPartial<UpdateProfileRequest>, I>>(base?: I): UpdateProfileRequest {
    return UpdateProfileRequest.fromPartial(base ?? {});
  },

  fromPartial<I extends Exact<DeepPartial<UpdateProfileRequest>, I>>(object: I): UpdateProfileRequest {
    const message = createBaseUpdateProfileRequest();
    message.displayName = object.displayName ?? undefined;
    message.photoUrl = object.photoUrl ?? undefined;
    return message;
  },
};

function createBaseGetProfileRequest(): GetProfileRequest {
  return { mask: undefined };
}

export const GetProfileRequest = {
  fromJSON(object: any): GetProfileRequest {
    return { mask: isSet(object.mask) ? FieldMask.unwrap(FieldMask.fromJSON(object.mask)) : undefined };
  },

  toJSON(message: GetProfileRequest): unknown {
    const obj: any = {};
    message.mask !== undefined && (obj.mask = FieldMask.toJSON(FieldMask.wrap(message.mask)));
    return obj;
  },

  create<I extends Exact<DeepPartial<GetProfileRequest>, I>>(base?: I): GetProfileRequest {
    return GetProfileRequest.fromPartial(base ?? {});
  },

  fromPartial<I extends Exact<DeepPartial<GetProfileRequest>, I>>(object: I): GetProfileRequest {
    const message = createBaseGetProfileRequest();
    message.mask = object.mask ?? undefined;
    return message;
  },
};

function createBaseRegisterPushTokenRequest(): RegisterPushTokenRequest {
  return { token: "" };
}

export const RegisterPushTokenRequest = {
  fromJSON(object: any): RegisterPushTokenRequest {
    return { token: isSet(object.token) ? String(object.token) : "" };
  },

  toJSON(message: RegisterPushTokenRequest): unknown {
    const obj: any = {};
    message.token !== undefined && (obj.token = message.token);
    return obj;
  },

  create<I extends Exact<DeepPartial<RegisterPushTokenRequest>, I>>(base?: I): RegisterPushTokenRequest {
    return RegisterPushTokenRequest.fromPartial(base ?? {});
  },

  fromPartial<I extends Exact<DeepPartial<RegisterPushTokenRequest>, I>>(object: I): RegisterPushTokenRequest {
    const message = createBaseRegisterPushTokenRequest();
    message.token = object.token ?? "";
    return message;
  },
};

function createBaseUnregisterPushTokenRequest(): UnregisterPushTokenRequest {
  return { token: "" };
}

export const UnregisterPushTokenRequest = {
  fromJSON(object: any): UnregisterPushTokenRequest {
    return { token: isSet(object.token) ? String(object.token) : "" };
  },

  toJSON(message: UnregisterPushTokenRequest): unknown {
    const obj: any = {};
    message.token !== undefined && (obj.token = message.token);
    return obj;
  },

  create<I extends Exact<DeepPartial<UnregisterPushTokenRequest>, I>>(base?: I): UnregisterPushTokenRequest {
    return UnregisterPushTokenRequest.fromPartial(base ?? {});
  },

  fromPartial<I extends Exact<DeepPartial<UnregisterPushTokenRequest>, I>>(object: I): UnregisterPushTokenRequest {
    const message = createBaseUnregisterPushTokenRequest();
    message.token = object.token ?? "";
    return message;
  },
};

function createBaseReceiptSettings(): ReceiptSettings {
  return { mobileBarcode: "", taxId: "", donateUnitId: "" };
}

export const ReceiptSettings = {
  fromJSON(object: any): ReceiptSettings {
    return {
      mobileBarcode: isSet(object.mobileBarcode) ? String(object.mobileBarcode) : "",
      taxId: isSet(object.taxId) ? String(object.taxId) : "",
      donateUnitId: isSet(object.donateUnitId) ? String(object.donateUnitId) : "",
    };
  },

  toJSON(message: ReceiptSettings): unknown {
    const obj: any = {};
    message.mobileBarcode !== undefined && (obj.mobileBarcode = message.mobileBarcode);
    message.taxId !== undefined && (obj.taxId = message.taxId);
    message.donateUnitId !== undefined && (obj.donateUnitId = message.donateUnitId);
    return obj;
  },

  create<I extends Exact<DeepPartial<ReceiptSettings>, I>>(base?: I): ReceiptSettings {
    return ReceiptSettings.fromPartial(base ?? {});
  },

  fromPartial<I extends Exact<DeepPartial<ReceiptSettings>, I>>(object: I): ReceiptSettings {
    const message = createBaseReceiptSettings();
    message.mobileBarcode = object.mobileBarcode ?? "";
    message.taxId = object.taxId ?? "";
    message.donateUnitId = object.donateUnitId ?? "";
    return message;
  },
};

function createBaseGetReceiptSettingsRequest(): GetReceiptSettingsRequest {
  return { mask: undefined };
}

export const GetReceiptSettingsRequest = {
  fromJSON(object: any): GetReceiptSettingsRequest {
    return { mask: isSet(object.mask) ? FieldMask.unwrap(FieldMask.fromJSON(object.mask)) : undefined };
  },

  toJSON(message: GetReceiptSettingsRequest): unknown {
    const obj: any = {};
    message.mask !== undefined && (obj.mask = FieldMask.toJSON(FieldMask.wrap(message.mask)));
    return obj;
  },

  create<I extends Exact<DeepPartial<GetReceiptSettingsRequest>, I>>(base?: I): GetReceiptSettingsRequest {
    return GetReceiptSettingsRequest.fromPartial(base ?? {});
  },

  fromPartial<I extends Exact<DeepPartial<GetReceiptSettingsRequest>, I>>(object: I): GetReceiptSettingsRequest {
    const message = createBaseGetReceiptSettingsRequest();
    message.mask = object.mask ?? undefined;
    return message;
  },
};

function createBaseGetReceiptSettingsResponse(): GetReceiptSettingsResponse {
  return { receiptSettings: undefined, donations: [], registrationSettings: undefined };
}

export const GetReceiptSettingsResponse = {
  fromJSON(object: any): GetReceiptSettingsResponse {
    return {
      receiptSettings: isSet(object.receiptSettings) ? ReceiptSettings.fromJSON(object.receiptSettings) : undefined,
      donations: Array.isArray(object?.donations)
        ? object.donations.map((e: any) => Receipt_DonationUnit.fromJSON(e))
        : [],
      registrationSettings: isSet(object.registrationSettings)
        ? GetReceiptSettingsResponse_RegistrationSettings.fromJSON(object.registrationSettings)
        : undefined,
    };
  },

  toJSON(message: GetReceiptSettingsResponse): unknown {
    const obj: any = {};
    message.receiptSettings !== undefined &&
      (obj.receiptSettings = message.receiptSettings ? ReceiptSettings.toJSON(message.receiptSettings) : undefined);
    if (message.donations) {
      obj.donations = message.donations.map((e) => e ? Receipt_DonationUnit.toJSON(e) : undefined);
    } else {
      obj.donations = [];
    }
    message.registrationSettings !== undefined && (obj.registrationSettings = message.registrationSettings
      ? GetReceiptSettingsResponse_RegistrationSettings.toJSON(message.registrationSettings)
      : undefined);
    return obj;
  },

  create<I extends Exact<DeepPartial<GetReceiptSettingsResponse>, I>>(base?: I): GetReceiptSettingsResponse {
    return GetReceiptSettingsResponse.fromPartial(base ?? {});
  },

  fromPartial<I extends Exact<DeepPartial<GetReceiptSettingsResponse>, I>>(object: I): GetReceiptSettingsResponse {
    const message = createBaseGetReceiptSettingsResponse();
    message.receiptSettings = (object.receiptSettings !== undefined && object.receiptSettings !== null)
      ? ReceiptSettings.fromPartial(object.receiptSettings)
      : undefined;
    message.donations = object.donations?.map((e) => Receipt_DonationUnit.fromPartial(e)) || [];
    message.registrationSettings = (object.registrationSettings !== undefined && object.registrationSettings !== null)
      ? GetReceiptSettingsResponse_RegistrationSettings.fromPartial(object.registrationSettings)
      : undefined;
    return message;
  },
};

function createBaseGetReceiptSettingsResponse_RegistrationSettings(): GetReceiptSettingsResponse_RegistrationSettings {
  return { companyId: "", cardType: "", cardNo: "", token: "", url: "" };
}

export const GetReceiptSettingsResponse_RegistrationSettings = {
  fromJSON(object: any): GetReceiptSettingsResponse_RegistrationSettings {
    return {
      companyId: isSet(object.companyId) ? String(object.companyId) : "",
      cardType: isSet(object.cardType) ? String(object.cardType) : "",
      cardNo: isSet(object.cardNo) ? String(object.cardNo) : "",
      token: isSet(object.token) ? String(object.token) : "",
      url: isSet(object.url) ? String(object.url) : "",
    };
  },

  toJSON(message: GetReceiptSettingsResponse_RegistrationSettings): unknown {
    const obj: any = {};
    message.companyId !== undefined && (obj.companyId = message.companyId);
    message.cardType !== undefined && (obj.cardType = message.cardType);
    message.cardNo !== undefined && (obj.cardNo = message.cardNo);
    message.token !== undefined && (obj.token = message.token);
    message.url !== undefined && (obj.url = message.url);
    return obj;
  },

  create<I extends Exact<DeepPartial<GetReceiptSettingsResponse_RegistrationSettings>, I>>(
    base?: I,
  ): GetReceiptSettingsResponse_RegistrationSettings {
    return GetReceiptSettingsResponse_RegistrationSettings.fromPartial(base ?? {});
  },

  fromPartial<I extends Exact<DeepPartial<GetReceiptSettingsResponse_RegistrationSettings>, I>>(
    object: I,
  ): GetReceiptSettingsResponse_RegistrationSettings {
    const message = createBaseGetReceiptSettingsResponse_RegistrationSettings();
    message.companyId = object.companyId ?? "";
    message.cardType = object.cardType ?? "";
    message.cardNo = object.cardNo ?? "";
    message.token = object.token ?? "";
    message.url = object.url ?? "";
    return message;
  },
};

function createBaseUpdateReceiptSettingsRequest(): UpdateReceiptSettingsRequest {
  return { receiptSettings: undefined };
}

export const UpdateReceiptSettingsRequest = {
  fromJSON(object: any): UpdateReceiptSettingsRequest {
    return {
      receiptSettings: isSet(object.receiptSettings) ? ReceiptSettings.fromJSON(object.receiptSettings) : undefined,
    };
  },

  toJSON(message: UpdateReceiptSettingsRequest): unknown {
    const obj: any = {};
    message.receiptSettings !== undefined &&
      (obj.receiptSettings = message.receiptSettings ? ReceiptSettings.toJSON(message.receiptSettings) : undefined);
    return obj;
  },

  create<I extends Exact<DeepPartial<UpdateReceiptSettingsRequest>, I>>(base?: I): UpdateReceiptSettingsRequest {
    return UpdateReceiptSettingsRequest.fromPartial(base ?? {});
  },

  fromPartial<I extends Exact<DeepPartial<UpdateReceiptSettingsRequest>, I>>(object: I): UpdateReceiptSettingsRequest {
    const message = createBaseUpdateReceiptSettingsRequest();
    message.receiptSettings = (object.receiptSettings !== undefined && object.receiptSettings !== null)
      ? ReceiptSettings.fromPartial(object.receiptSettings)
      : undefined;
    return message;
  },
};

function createBaseUpdateReceiptSettingsResponse(): UpdateReceiptSettingsResponse {
  return { receiptSettings: undefined };
}

export const UpdateReceiptSettingsResponse = {
  fromJSON(object: any): UpdateReceiptSettingsResponse {
    return {
      receiptSettings: isSet(object.receiptSettings) ? ReceiptSettings.fromJSON(object.receiptSettings) : undefined,
    };
  },

  toJSON(message: UpdateReceiptSettingsResponse): unknown {
    const obj: any = {};
    message.receiptSettings !== undefined &&
      (obj.receiptSettings = message.receiptSettings ? ReceiptSettings.toJSON(message.receiptSettings) : undefined);
    return obj;
  },

  create<I extends Exact<DeepPartial<UpdateReceiptSettingsResponse>, I>>(base?: I): UpdateReceiptSettingsResponse {
    return UpdateReceiptSettingsResponse.fromPartial(base ?? {});
  },

  fromPartial<I extends Exact<DeepPartial<UpdateReceiptSettingsResponse>, I>>(
    object: I,
  ): UpdateReceiptSettingsResponse {
    const message = createBaseUpdateReceiptSettingsResponse();
    message.receiptSettings = (object.receiptSettings !== undefined && object.receiptSettings !== null)
      ? ReceiptSettings.fromPartial(object.receiptSettings)
      : undefined;
    return message;
  },
};

function createBaseGetPushSettingsRequest(): GetPushSettingsRequest {
  return { mask: undefined };
}

export const GetPushSettingsRequest = {
  fromJSON(object: any): GetPushSettingsRequest {
    return { mask: isSet(object.mask) ? FieldMask.unwrap(FieldMask.fromJSON(object.mask)) : undefined };
  },

  toJSON(message: GetPushSettingsRequest): unknown {
    const obj: any = {};
    message.mask !== undefined && (obj.mask = FieldMask.toJSON(FieldMask.wrap(message.mask)));
    return obj;
  },

  create<I extends Exact<DeepPartial<GetPushSettingsRequest>, I>>(base?: I): GetPushSettingsRequest {
    return GetPushSettingsRequest.fromPartial(base ?? {});
  },

  fromPartial<I extends Exact<DeepPartial<GetPushSettingsRequest>, I>>(object: I): GetPushSettingsRequest {
    const message = createBaseGetPushSettingsRequest();
    message.mask = object.mask ?? undefined;
    return message;
  },
};

function createBaseUpdatePushSettingsRequest(): UpdatePushSettingsRequest {
  return { settings: undefined, updateMask: undefined };
}

export const UpdatePushSettingsRequest = {
  fromJSON(object: any): UpdatePushSettingsRequest {
    return {
      settings: isSet(object.settings) ? PushSettings.fromJSON(object.settings) : undefined,
      updateMask: isSet(object.updateMask) ? FieldMask.unwrap(FieldMask.fromJSON(object.updateMask)) : undefined,
    };
  },

  toJSON(message: UpdatePushSettingsRequest): unknown {
    const obj: any = {};
    message.settings !== undefined &&
      (obj.settings = message.settings ? PushSettings.toJSON(message.settings) : undefined);
    message.updateMask !== undefined && (obj.updateMask = FieldMask.toJSON(FieldMask.wrap(message.updateMask)));
    return obj;
  },

  create<I extends Exact<DeepPartial<UpdatePushSettingsRequest>, I>>(base?: I): UpdatePushSettingsRequest {
    return UpdatePushSettingsRequest.fromPartial(base ?? {});
  },

  fromPartial<I extends Exact<DeepPartial<UpdatePushSettingsRequest>, I>>(object: I): UpdatePushSettingsRequest {
    const message = createBaseUpdatePushSettingsRequest();
    message.settings = (object.settings !== undefined && object.settings !== null)
      ? PushSettings.fromPartial(object.settings)
      : undefined;
    message.updateMask = object.updateMask ?? undefined;
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends Array<infer U> ? Array<DeepPartial<U>> : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}
